import { Middleware } from "redux";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { Events } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";

import { LINKS_ACTIVITY } from "./constants";

/**
 * Schließt die Links-Activity, wenn der Prozess gestartet wird (Event-Button).
 * Andernfalls wird ein Bug ausgelöst, der durch die Interaktion zwischen Workflows und Client entsteht und eine Endlosschleife
 * zur Folge hat.
 */
export const closeLinksMiddleware: Middleware = api => next => action => {
	if (FormEngineActions.event.match(action) && Events.eventButton.match(action.payload.engineEvent)) {
		const { engineEvent } = action.payload;
		if (Events.eventButton.match(engineEvent)) {
			if (engineEvent.payload.name === "proceed" && ActivitySelectors.activityById(LINKS_ACTIVITY)) {
				api.dispatch(ActivityActions.cancel({ activityId: LINKS_ACTIVITY }));
			}
		}
	}
	return next(action);
};
